import { Dialog, IconButton, styled } from '@mui/material'

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  zIndex: 9999
}))
